import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivSpecialRoot = styled.div<{ existSpecialEpisodeTab: boolean }>`
  position: relative;
  margin-bottom: 32px;
  ${({ existSpecialEpisodeTab }) => !existSpecialEpisodeTab && `margin-top: 32px;`}

  ${mq.sp} {
    margin-bottom: 16px;
    ${({ existSpecialEpisodeTab }) => !existSpecialEpisodeTab && `margin-top: 16px;`}
  }
`;

export const DivTagListCarouselBox = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;
